import { render, staticRenderFns } from "./liquorOrder.vue?vue&type=template&id=ed87319c&scoped=true"
import script from "./liquorOrder.vue?vue&type=script&lang=js"
export * from "./liquorOrder.vue?vue&type=script&lang=js"
import style0 from "./liquorOrder.vue?vue&type=style&index=0&id=ed87319c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed87319c",
  null
  
)

export default component.exports